import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { CompanyLeadSubscriptionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const companyLeadSubscriptionsQuery = graphql(`
  query companyLeadSubscriptions {
    companyLeadSubscriptions {
      id
      destinationSettings {
        type
        name
        webhookUrl
      }
      frequency
      disabled
      pausedByRefusals
      views {
        id
        name
        description
        dataType
        contentId
      }
    }
  }
`);

export function useCompanyLeadSubscriptions(
  options?: UseQueryOptions<
    CompanyLeadSubscriptionsQuery,
    unknown,
    CompanyLeadSubscriptionsQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["companyLeadSubscriptions"],
    companyLeadSubscriptionsQuery,
    [],
    { ...options },
  );

  return { data: data?.companyLeadSubscriptions, ...rest };
}
